import request from '@/api/request'

export const login = params => request('loginHttp', { params })
export const logout = params => request('logoutHttp', { params })